import {ContactDto} from "./contact.dto";
import {AddressDto} from "./address.dto";
import {RegistryOfficeDto} from "./registry-office.dto";
import {isDefined} from "../../libs/utils/epic.utils";
import {DeathType} from "../../libs/enum/death-type.enum";
import {Pacemaker} from "../../libs/enum/pacemaker.enum";
import {CoffinSize} from "../../libs/enum/coffin-size.enum";
import {Infectious} from "../../libs/enum/infectious.enum";

export class DeathDto {

  public readonly id!: string;
  public deathType!: DeathType;
  public autopsy: string | undefined;
  public timeOfDeath: Date | undefined;
  public lastSeenAlive: Date | undefined;
  public timeOfDiscovery: Date | undefined;
  public valuables: string | undefined;
  public fileReferenceNumber: string | undefined;
  public pacemaker!: Pacemaker;
  public coffinSize!: CoffinSize;
  public infectious!: Infectious;
  public readonly deceasedId!: string;
  public readonly deceased!: ContactDto;
  public debtorId: string | undefined;
  public readonly debtor: ContactDto | undefined;
  public medicalId: string | undefined;
  public readonly medical: ContactDto | undefined;
  public readonly placeOfDeathId: string | undefined;
  public readonly placeOfDeath: AddressDto | undefined;
  public registryOfficeId: string | undefined;
  public readonly registryOffice: RegistryOfficeDto | undefined;

  constructor(init?: Partial<DeathDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.timeOfDeath)) {
      this.timeOfDeath = new Date(init.timeOfDeath);
    }
    if (isDefined(init?.lastSeenAlive)) {
      this.lastSeenAlive = new Date(init.lastSeenAlive);
    }
    if (isDefined(init?.timeOfDiscovery)) {
      this.timeOfDiscovery = new Date(init.timeOfDiscovery);
    }
    if (isDefined(this.deceased)) {
      this.deceased = new ContactDto(this.deceased);
    }
    if (isDefined(this.debtor)) {
      this.debtor = new ContactDto(this.debtor);
    }
    if (isDefined(this.medical)) {
      this.medical = new ContactDto(this.medical);
    }
    if (isDefined(this.placeOfDeath)) {
      this.placeOfDeath = new AddressDto(this.placeOfDeath);
    }
    if (isDefined(this.registryOffice)) {
      this.registryOffice = new RegistryOfficeDto(this.registryOffice);
    }
  }

  public isEditable(): boolean {
    return true;
  }
}
